import type { ColumnDef } from "@tanstack/react-table";
import type { ApInvoice } from "@/accounts-payable/types";
import { formatApDate } from "@/accounts-payable/utils";

export const dateCol: ColumnDef<ApInvoice> = {
  accessorKey: "invoice_date",
  header: "Invoice date",
  meta: { size: "120px" },
  cell: ({ row }) => <span>{formatApDate(row.original.invoice_date)}</span>,
};
